import mixin from './mixin';

export default function (receiver, suppliers) {
    const receiverProps = Object.getOwnPropertyNames(receiver);
    receiverProps.forEach((prop) => delete receiver[prop]);

    return suppliers.map((supplier) => mixin(receiver, supplier));
}
